export const routesName = {
  adp: 'ADP',
  amendment: 'Amendment',
  'annual-report': 'Annual Report',
  'basic-email': 'Business email',
  'beneficial-ownership-filing': 'Beneficial Ownership Filing',
  'business-credit-card': 'Business Credit Card',
  'business-kit': 'Business kit',
  'business-licenses': 'Business license',
  'business-license-report': 'Business license report',
  'business-license-filing': 'Business License Filing',
  'change-of-registered-agent': 'Registered Agent Service',
  'constant-contact': 'Constant Contact',
  'corp-formation': 'C-Corp Filing',
  'corporate-bylaws': 'Corporate Bylaws',
  'corporate-docs': 'Business Document Templates',
  'dba-entity': 'DBA (Doing Business As)',
  'domain-name-reg': 'Domain Name Registration',
  'ein-creation': 'EIN',
  'initial-report': 'First Statement of Information Service',
  'legal-shield': 'LegalShield',
  'llc-formation': 'LLC Formation',
  'money-pro': 'Money Pro',
  'next-insurance': 'NEXT Insurance',
  'ny-publication': 'New York Publication Service',
  ocoya: 'Social Media Management',
  'operating-agreement': 'Operating Agreement Template',
  'registered-agent': 'Registered Agent Service',
  's-corp-bundle': 'S Corp Bundle',
  's-corp-designator': 'S Corp Filing',
  'standard-good-standing': 'Standard Good Standing',
  'tax-advice': 'Tax Advice',
  'quarterly-tax-planning': 'Quarterly Tax Planning',
  'tax-filing': 'Tax Filing',
  'trademarks-search': 'Trademark',
  'website-tools-bundle': 'Online Tools',
  'wfc-advanced': 'Worry-Free Compliance',
  'wfc-services': 'Worry-Free Compliance',
  'logo-kit': 'Logo Kit',
  'static-website': 'Website Builder'
};
